
export const crmTags = (tags) => {
  if (!tags || tags.length === 0) { return [] }
  return tags.filter(tag => tag.startsWith('crm:')).map(name => name.split(':')[2])
}
